import Cookies from "js-cookie";
// Custom error for API failures, moved from types.ts
class ApiError extends Error {
  constructor(message, code) {
    super(message);
    this.name = 'ApiError';
    this.code = code;
    Object.setPrototypeOf(this, ApiError.prototype); // For correct instanceof checks
  }
}

let url;

if (window.location.href.includes("localhost")) {
  url = "http://localhost:5000";
} else if (window.location.href.includes("staging")) {
  url = `http://staging.cpanel.api.credin.in`;
} else {
  url = "https://cpanelapi.credin.in";
}

console.log(url);
// const API_BASE_URL = 'http://localhost:5000'; // In a production app, this would come from an environment variable.
const API_BASE_URL = url;

/**
 * Fetches data from the Loan Analytics API for a specific user.
 * @param {object} filters The filters to apply to the data.
 * @returns {Promise<object>} A promise that resolves to the dashboard data.
 */
export async function getAnalyticsData(filters) {
  // In a real app, the user's email would come from an authentication context (e.g., JWT, session).
  // For this demo, we'll hardcode it to simulate a logged-in user.
  // const userEmail = 'aayant.todi@credin.in'; 
  // const userEmail = 'bittu.kumar@credin.in'; 
  const userEmail = Cookies.get("Email"); 

  console.log(`Fetching real loan data for user ${userEmail} with filters:`, filters);

  try {
    const response = await fetch(`${API_BASE_URL}/lead/api/analytics`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      // The backend now expects a userEmail along with the filters.
      body: JSON.stringify({ ...filters, userEmail }),
    });

    if (!response.ok) {
      let errorMessage = `API Error: ${response.status} ${response.statusText}`;
      try {
          // Try to get a more specific error message from the backend response body.
          const errorBody = await response.json();
          errorMessage = errorBody.message || errorMessage;
      } catch (e) {
          // Ignore if the response body isn't valid JSON.
      }
      throw new ApiError(errorMessage, response.status);
    }

    const data = await response.json();
    return data;

  } catch (error) {
    if (error instanceof ApiError) {
      // Re-throw custom API errors so the UI can handle them gracefully.
      throw error;
    }
    // Handle network errors (e.g., server is down, no internet) or other unexpected issues.
    console.error("Network or unexpected error in getAnalyticsData:", error);
    throw new Error("Failed to fetch data. Please check your network connection and ensure the backend server is running.");
  }
}